<template>
    <div ref="aboutPage" class="about-page">
        <p class="about-content">
            <TerminalSimulator 
            referrer="aboutpage"
            text="
                    Im <strong>Februar 2021</strong>, habe ich mit vollem Herzblut meine Umschulung<br> zum Fachinformatiker (Anwendungsentwicklung) begonnen, die ich im Januar 2023 erfolgreich abgeschlossen habe.<br> 
                    Nebenbei habe ich mich auch seitdem überwiegend mit Web-Technologien beschäftigt.<br>Paar Online-Kurse habe ich diesbzüglich auf Udemy.com, und&nbsp;OpenHPI gemacht. 
                    Und zwar:<br> <strong>„Wegweisende Anwendungen im Web - Open.hpi.de“</strong>
                    <br><strong>„Die komplette JavaScript Masterclass - Udemy.com“</strong>
                    <br><strong>„Die komplette Web-Entwickler Masterclass - Udemy.com“</strong>
                    <br>und
                    <br><strong>Complete React Developer in 2023 (Redux, Hooks, GraphQL) - Udemy.com“</strong>
                    <br>Außerdem bin ich während der Programmiermodule der Umschulung mit Java in Berührung gekommen. 
                    <br>zum Thema Java habe ich auch den folgenden Online-Kurs auf OpenHPI gemacht:
                    <br><strong>„Algorithmen und Datenstrukturen mit Detektiv Duke - Open.hpi.de“</strong>
                    <br>Seit <strong>Februar 2023</strong> arbeite ich bei der Dsa-Marketing AG. Hier realisiere ich sowohl Frontend als auch Backend (Node.js, PHP) Web-Projekte. 
                    <br>Als Allrounder gehören auch zu meinen Aufgaben unter anderem  [ <b>Wordpress plugins, Shopware 6 plugins u.v.m.</b> ]
                " 
                :isWritten="pageLoadingStore.isLoaded('aboutpage')" 
                @textIsWritten="pageLoadingStore.setLoaded('aboutpage',true)"
            />
        </p>
    </div>
</template>

<script>
    import TerminalSimulator from '../components/TerminalSimulator.vue';
    import { usePageLoadingStore } from '../stores/pageLoadingStore.js';

    export default {
        __name: 'AboutPage',
        data() {

        },
        setup(){
            const pageLoadingStore = usePageLoadingStore();
            return {
                pageLoadingStore
            }
        },
        components:{
            TerminalSimulator
        }
    }
</script>

<style scoped>

.about-page{
    color: rgb(255, 255, 255);
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: bolder;
    font-family: orbitron;
    font-size: v-bind(size+"px");
    position: absolute;
    top: 50%;
    bottom: 50%;
    position: relative;


    h1{
        font-size: x-large;
    }
    p{
        font-size: large;
        max-width: 90%;
        text-align: center;
        background-color: #00000069;
    }
}

</style>
